<template>
  <div class="wrap wrap_head_input_nodeep">
    <div class="shade-top"></div>
    <div class="head">
      <!-- <h4 class="title">企业资讯</h4> -->

      <div class="autocompleteWrap">
        <el-autocomplete ref="autoSelect" popper-class="newsDetails-head-autocomplete" clearable :maxlength="50"  v-model.trim="input" :fetch-suggestions="querySearch"
          v-on:keyup.enter.native="handleIconClick" placeholder="请输入企业名称" @select="handleSelect">
          <!-- <el-button slot="append" class="fr" icon="el-icon-search" @click="handleIconClick">搜索</el-button> -->
          <el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button>
          
          <template slot-scope="{ item }">
            <div class="name textOverflow" v-html="item.name"></div>
          </template>
        </el-autocomplete>
      </div>
    </div>
<!-- 
    <div class="search-head">
        <el-input  ref="autoSelect" placeholder="请输入企业名称" v-model.trim="input" clearable :fetch-suggestions="querySearch" v-on:keyup.enter.native="handleIconClick">
          <el-button slot="append" icon="el-icon-search" @click="handleIconClick"></el-button>
        </el-input>
    </div> -->

    <div class="block" v-loading='waiting'>
      <!-- <el-timeline>
        <el-timeline-item v-for="(item,index) in cardList" :key="index" :timestamp="item.rtm | getTime" placement="top">
          <el-card class="elCard">
            <a class="h4" :href="item.uri" target="about">{{item.title}}</a>
            <p v-html="item.abstracts"></p>
            <div class="message">
              <div>来源：<a :href="item.uri" target="about">{{item.website}}</a></div>
              <div>发布时间：<span>{{item.rtm | getTimeDescribe}}</span></div>
            </div>
            <div class="about">相关：<span>{{item.companyName}}</span></div>
          </el-card>
        </el-timeline-item>
      </el-timeline> -->

      <div v-for="(item,index) in cardList" :key="index" >
          <el-card class="elCard">
            <a class="h4" :href="item.uri" target="about">{{item.title}}</a>
            <p v-html="item.abstracts"></p>
            <div class="message">
              <div>来源：<a :href="item.uri" target="about">{{item.website}}</a></div>
              <div style="margin-left:15px">发布时间：<span>{{item.rtm | getTimeDescribe}}</span></div>
            </div>
            <div class="about">关联企业：<span>{{item.companyName}}</span></div>
          </el-card>
      </div>


      <div class="pagination" v-if="cardList.length">
        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <!-- <div class="goHome" @click="$router.push({path:'/clue/index'})">返回</div> -->
      </div>
      <div v-else class="nofind">
        <!-- <img class="pic-403__parent" src="@/assets/404_images/404s.png" alt="403"> -->
        <img class="pic-403__parent" src="@/assets/nofind.png" alt="403">
        <h1 class="pic-403__h1" style="color: #aaa">请去右上角输入企业全称，搜索企业最新资讯！</h1>

      </div>
    </div>
    <robot />
  </div>
</template>
<script>
import { getNews, getByName } from '../api/newClueApi'
// import { getStarCompany } from '../api/index'
import Robot from '../components/robot'
import { X_BLOCK } from '@/utils/iframeUtils'

export default {
  components: {
    Robot
  },
  data () {
    return {
      input: '',
      restaurants: [],
      lastSearch: '',
      lastSearchArr: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      cardList: [],

      waiting: false
    }
  },
  mounted() {
    // this.loadAll()

    this.getNews(true)
    if (!window[X_BLOCK]){
      document.querySelector('.pageWrap').setAttribute('style', 'margin-top: -44px;')
    }
    
  },
  beforeDestroy() {
    if (!window[X_BLOCK]){
      document.querySelector('.pageWrap').setAttribute('style', 'margin-top: auto;')
    }
    
  },
  filters: {
    getTimeDescribe(val) {
      const nowTime = Date.parse(new Date()) //当前时间戳
      const year = (nowTime - val) / (12 * 30 * 24 * 60 * 60 * 1000)
      if (year > 1) return Math.floor(year) + '年前'
      const month = (nowTime - val) / (30 * 24 * 60 * 60 * 1000)
      if (month > 1) return Math.floor(month) + '月前'
      const day = (nowTime - val) / (24 * 60 * 60 * 1000)
      if (day > 1) return Math.floor(day) + '天前'
      const hour = (nowTime - val) / (60 * 60 * 1000)
      if (hour > 1) return Math.floor(hour) + '小时前'
      const min = (nowTime - val) / (60 * 1000)
      if (min > 1) return Math.floor(min) + '分钟前'
    },
    getTime(s) {
      const date = new Date(s)
      let month = date.getMonth()
      let day = date.getDate()
      let hours = date.getHours()
      let min = date.getMinutes()
      let second = date.getSeconds()

      if (month < 9) {
        month = '0' + (month + 1)
      } else {
        month = month + 1
      }
      if (day < 10) {
        day = '0' + day
      }
      if (hours < 10) {
        hours = '0' + hours
      }
      if (min < 10) {
        min = '0' + min
      }
      if (second < 10) {
        second = '0' + second
      }
      return `${date.getFullYear()}-${month}-${day} ${hours}:${min}:${second}`
    }
  },
  methods: {
    async getByName(name) {
      const res = await getByName({ name })
      return res.data.map(e => {
        return {
          name: e.companyName,
          value: e.unlabeledCompanyName
        }
      })
    },
    async querySearch(queryString, cb) {
      if (queryString.length > 1) {
        if (this.lastSearch !== this.input) {
          this.lastSearch = this.input
          const res = await this.getByName(queryString)
          this.lastSearchArr = res
        }
        cb(this.lastSearchArr);
      }
      else {
        //  this.lastSearch = this.input
        cb(this.restaurants)
      }
    },
    // async loadAll() {
    //   // 获取所有搜藏  后端说先传1万
    //   const data = {
    //     type: 1,
    //     pageNum: 1,
    //     pageSize: 10000
    //   }
    //   const res = await getStarCompany(data)

    //   this.restaurants = res.data.records.map(e => {
    //     return { value: e.name, history: '收藏过' }
    //   })
    // },

    handleSelect(item) {
      console.log(item);
    },
    handleIconClick() {
      this.$refs.autoSelect.close()

      this.currentPage = 1
      if (!this.input) {
        this.$message.warning('请输入企业名称')
      } else {
        this.getNews()
      }
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getNews()
    },


    async getNews(init) {
      this.waiting = true
      this.cardList = []
      const res = await getNews({
        name: this.input || this.$route.params.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.data) {
        this.cardList = res.data.items
        this.total = res.data.total
      } else {

        if (init) {
          this.$message.warning('请去右上角输入企业全称，搜索企业最新资讯！')

        } else {
          this.$message.warning('暂无相关资讯！')

        }
      }
      this.waiting = false

    },
  }
}
</script>
<style lang="scss" scoped>
.wrap_head_input_nodeep{
  padding-top: 54px;
}
.wrap {
  // background-color: #fff;
  .head {
    // padding: 0 50px 0 20px;
    // height: 60px;
    // line-height: 60px;
    // display: flex;
    // justify-content: space-between;
    // border-bottom: 1px solid #f0f2f5;

        width: 217px;
    height: 34px;
    padding: 0;
        position: absolute;
    right: 0;
    top: 0;
    z-index: 1000;
    // position: fixed;
    // top: -45px;
    h4 {
      font-weight: 650;
      font-size: 16px;
    }
    .autocompleteWrap {
      width: 217px;
      // .el-autocomplete {
      //   width: 100%;
      //   height: 34px;
      //   line-height: 34px;
      // }
    }
    // /deep/ .el-input-group__append{
    //       background: none;
    // background-color: #fff;
    // border-left: 1px solid #ffffff;
    // }
    // /deep/ .el-input-group--append .el-input__inner{
    //       border-right: 1px solid #fff;
    // }
    // /deep/ .el-input--suffix {
    //   font-size: 12px;
    //   .el-input__inner {
    //     padding-right: 110px;
    //     font-size: 12px;
    //   }
    //   .el-input__suffix {
    //     right: 0px;
    //     font-size: 12px;

    //     .el-button {
    //       padding: 8px 15px;
    //       border-radius: 0 4px 4px 0;
    //       font-size: 12px;
    //       height: 32px;
    //     }
    //   }
    // }
  }
  .block {
    // padding: 50px 50px 85px 85px;
    .elCard {
      margin-bottom: 16px;
      .h4 {
        font-weight: bold;
        font-style: normal;
        font-size: 16px;
        color: #333333;
      }
      p {
        margin: 10px 0;
        font-size: 13px;
        color: #666666;
      }
      .message {
        display: flex;
        // justify-content: space-between;
        margin-bottom: 3px;
        > div {
          color: #999999;
          font-size: 12px;
          > span {
            font-size: 12px;
          }
        }
      }
      .about {
        font-size: 12px;
        color: #999999;
        > span {
          font-size: 12px;
          color: #507afb;
        }
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: center;
      .goHome {
        width: 60px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        color: #fff;
        background-color: #419efb;
        position: relative;
        top: -30px;
      }
      .goHome:hover {
        background-color: #507afb;
      }
    }
  }
}
/deep/ {
  .elCard{
    .el-card__body{
      padding: 24px 30px;
    }
  }
}

.nofind {
  text-align: center;
  margin-top: 100px;
  .pic-403__parent {
    // width: 249px;
    // height: 190px;
  }
  .pic-403__text {
    width: 153px;
    height: 68px;
    margin-top: 110px;
    margin-left: 80px;
  }
  .pic-403__h1 {
    margin-top: 50px;
    font-size: 16px;
    color: #333;
    font-weight: 400;
    b {
      color: #ff6600;
      font-size: 24px;
    }
  }
}

// /deep/ {
//   .pageWrap{
//       margin-top: -44px;
//   }
// }
.shade-top{
background-color: #F5F6F8;
    height: 52px;
    margin: 0 -10px;
    position: absolute;
    top: 0;
    width: 100%;
    left: 10px;
}
</style>



<style lang="scss">
.newsDetails-head-autocomplete {
  /deep/ .el-scrollbar__view {
    li {
      position: relative;
      padding: 0 20px 0 20px;
      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .addr {
        position: absolute;
        top: 0;
        right: 20px;
        font-size: 12px;
        color: #f59a23;
      }
    }

    // padding-right: 80px;
  }
}
</style>


